import { useEffect, useState } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { useSiteCopy } from "@/lib/copy";

export default function Contact() {
  const t = useSiteCopy();
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings/public").then(r => setS(r.data)); }, []);
  return (
    <div className="mx-auto max-w-4xl px-5 py-16 md:px-8 md:py-24">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{t("contact.eyebrow", "Contact")}</span>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900 md:text-5xl wavy">{t("contact.title", "Talk to a real human.")}</h1>
      <p className="mt-3 text-slate-600">{t("contact.subtitle", "Use the channel you prefer — or skip ahead and request a quote.")}</p>
      <div className="mt-10 grid gap-5 md:grid-cols-3">
        <div className="rounded-2xl border border-cyan-100 bg-white p-6">
          <Phone className="h-5 w-5 text-cyan-700" />
          <div className="mt-3 font-display text-lg font-bold">Phone</div>
          <div className="mt-1 text-slate-600">{s.contact_phone || "Set in dashboard"}</div>
        </div>
        <div className="rounded-2xl border border-cyan-100 bg-white p-6">
          <Mail className="h-5 w-5 text-cyan-700" />
          <div className="mt-3 font-display text-lg font-bold">Email</div>
          <div className="mt-1 text-slate-600">{s.contact_email || "Set in dashboard"}</div>
        </div>
        <div className="rounded-2xl border border-cyan-100 bg-white p-6">
          <MapPin className="h-5 w-5 text-cyan-700" />
          <div className="mt-3 font-display text-lg font-bold">Service area</div>
          <div className="mt-1 text-slate-600">{s.address || "Available on request"}</div>
        </div>
      </div>
      <div className="mt-10">
        <Link to="/quote" className="btn-aqua" data-testid="contact-cta-quote-link">{t("contact.cta_button", "Request a quote →")}</Link>
      </div>
    </div>
  );
}
